import type { ComponentSchema } from '../../../schema-types'
import { SECTION_STYLE_FIELDS } from '../../lightings/lightings-1/_builder-constants'

/** Power supply sizing: CPU and graphics card wattage → estimated draw and the recommended PSU. */
export const schema: ComponentSchema = {
  type: 'power-calculator',
  label: 'Power supply calculator',
  description: 'Shoppers pick a processor and graphics card and see the power supply their PC needs.',
  supportedPages: ['tools'],
  variants: [{ id: 'v1', label: 'Calculator' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Power supply calculator' },
    { key: 'intro', label: 'Intro', type: 'text', default: 'Pick your processor and graphics card to find the power supply you need.' },
    {
      key: 'presets',
      label: 'Quick picks',
      type: 'array',
      itemSchema: [
        { key: 'label', label: 'Name', type: 'string' },
        { key: 'kind', label: 'Part', type: 'select', options: [{ label: 'Processor', value: 'cpu' }, { label: 'Graphics card', value: 'gpu' }], default: 'cpu' },
        { key: 'watts', label: 'Wattage (W)', type: 'number', default: 65 },
      ],
      default: [
        { label: 'Entry processor (65 W)', kind: 'cpu', watts: 65 },
        { label: 'Mid-range processor (105 W)', kind: 'cpu', watts: 105 },
        { label: 'High-end processor (170 W)', kind: 'cpu', watts: 170 },
        { label: 'Entry graphics (115 W)', kind: 'gpu', watts: 115 },
        { label: 'Mid-range graphics (220 W)', kind: 'gpu', watts: 220 },
        { label: 'High-end graphics (350 W)', kind: 'gpu', watts: 350 },
      ],
    },
    { key: 'headroomPercent', label: 'Spare capacity (%)', type: 'number', default: 30, help: 'Added on top of the estimated draw.' },
    ...SECTION_STYLE_FIELDS,
  ],
}
